import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Decadence} from "../Decadence";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {gsap} from "gsap"
import {DecadenceStatics} from "../config/DecadenceStatics";
import {DecadenceModel} from "../server/DecadenceModel";

export class DecadenceReelStopFlow implements FlowStatePresentation {

    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        const tl = gsap.timeline();

        tl.add(() => {
            flowStateController.setSkipCallback();
            //flowStateController.setSkipCallback(() => {
            //    tl.seek("end", false);
            //})
        })

        const isFastSpin = Decadence.apiPlugin.settings.get(APISetting.FAST_SPIN);
        const stopAnimation = isFastSpin ?
            Decadence.reelView.stopActiveReels(DecadenceStatics.reelStopDelayFastSpin) : Decadence.reelView.stopActiveReels(DecadenceStatics.reelStopDelay);

        const jurPadding = Decadence.gameFlowController.calculatePaddingDuration(stopAnimation.duration());
        tl.add(stopAnimation, `>${Math.max(jurPadding)}`);
        tl.addLabel("end");

        tl.add(() => {
            flowStateController.finish()
        }, ">0.2");
    }
}